import React from "react";

export default function Sidebar({ activeTab, setActiveTab, handleLogout }) {
  const tabs = [
    { id: "dashboard", label: "📊 Dashboard" },
    { id: "campaigns", label: "📢 Campaigns" },
    { id: "agents", label: "👥 Agent Metrics" },
    { id: "leads", label: "🎯 Leads" },
    { id: "revenue", label: "💰 Revenue Facts" }
  ];

  return (
    <aside className="w-64 bg-slate-900 text-white shadow-xl h-screen flex flex-col justify-between">
      <div>
        <div className="p-6 flex items-center gap-3 border-b border-slate-800">
          <img src="/logo.png" alt="Logo" className="w-10 h-10" onError={(e) => e.target.style.display='none'} />
          <h2 className="text-xl font-bold tracking-tight">Anvexa AI Solutions</h2>
        </div>
        
        <nav className="p-4 space-y-2 mt-4">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`w-full flex items-center text-left px-4 py-3 rounded-lg font-medium transition-all duration-200 ${
                activeTab === tab.id
                  ? "bg-blue-600 text-white shadow-sm"
                  : "text-slate-400 hover:bg-slate-800 hover:text-white"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="p-6 border-t border-slate-800">
        <button
          onClick={handleLogout}
          className="w-full bg-slate-800 hover:bg-red-600 text-slate-300 hover:text-white px-4 py-2 rounded-lg font-semibold transition"
        >
          Log Out
        </button>
      </div>
    </aside>
  );
}